export const localDateTime = (value) => {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const pad = (number) => String(number).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export const initialValues = (config, record = {}) => config.fields.reduce((values, field) => {
  if (field.type === 'file') values[field.key] = null
  else if (field.type === 'checkbox') values[field.key] = record[field.key] === undefined ? Boolean(field.defaultValue) : Boolean(record[field.key])
  else if (field.type === 'datetime-local') values[field.key] = localDateTime(record[field.key])
  else if (field.multiple) values[field.key] = record[field.key] || []
  else values[field.key] = record[field.key] ?? ''
  return values
}, {})

export const buildPayload = (config, values, editing) => {
  const payload = new FormData()
  config.fields.filter((field) => !(editing && field.createOnly) && !(!editing && field.editOnly)).forEach((field) => {
    const value = values[field.key]
    if (field.type === 'file') {
      if (value) Array.from(field.multiple ? value : [ value ]).forEach((file) => payload.append(field.multiple ? `${field.key}[]` : field.key, file))
    } else if (field.multiple) {
      // An empty sentinel lets Rails clear all linked products on edit.
      const list = value?.length ? value : [ '' ]
      list.forEach((item) => payload.append(`${field.key}[]`, item))
    } else if (field.type === 'datetime-local') {
      if (value) payload.append(field.key, new Date(value).toISOString())
    } else payload.append(field.key, field.type === 'checkbox' ? String(Boolean(value)) : value ?? '')
  })
  ;(values.remove_supporting_image_ids || []).forEach((id) => payload.append('remove_supporting_image_ids[]', id))
  return payload
}

export const display = (value) => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  if (value === null || value === undefined || value === '') return '-'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]))

export const invoiceHtml = (invoice) => {
  const totals = {}
  const rows = (invoice.items || []).map((item) => {
    const quantity = Number(item.quantity ?? 1)
    const amount = Number(item.amount || 0)
    const currency = item.currency || 'IDR'
    totals[currency] = (totals[currency] || 0) + quantity * amount
    return `<tr><td>${escapeHtml(item.sku)}</td><td>${escapeHtml(item.title)}<br>${escapeHtml(item.description)}</td><td>${quantity}</td><td>${escapeHtml(currency)} ${amount.toLocaleString('id-ID')}</td><td>${escapeHtml(currency)} ${(quantity * amount).toLocaleString('id-ID')}</td></tr>`
  }).join('')
  return `<!doctype html><html><head><title>${escapeHtml(invoice.title || `Invoice #${invoice.id}`)}</title><style>body{font-family:Arial,sans-serif;margin:40px;color:#222}table{border-collapse:collapse;width:100%;margin-top:24px}th,td{padding:10px;border-bottom:1px solid #ddd;text-align:left}small{color:#555}@media print{button{display:none}}</style></head><body><button onclick="window.print()">Print / Save PDF</button><h1>${escapeHtml(invoice.title || `Invoice #${invoice.id}`)}</h1><p>${escapeHtml(invoice.customer_name)}<br>${escapeHtml(invoice.customer_address)}<br>${escapeHtml(invoice.customer_phone)}</p><p>Date: ${escapeHtml(invoice.invoice_date)}<br>Client Advisor: ${escapeHtml(invoice.client_advisor)}<br>Shipped Via: ${escapeHtml(invoice.shipped_via)}</p><table><thead><tr><th>SKU</th><th>Item</th><th>Qty</th><th>Unit Price</th><th>Total</th></tr></thead><tbody>${rows}</tbody></table>${Object.keys(totals).map((currency) => `<p>Total ${escapeHtml(currency)}: ${totals[currency].toLocaleString('id-ID')}</p>`).join('')}<p>Down Payment (tersimpan): ${escapeHtml(invoice.down_payment ?? '-')}</p><small>Arsip invoice #${invoice.id}. Cetak ulang tidak mengubah stok.</small></body></html>`
}
